"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockClasses = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _theme = _interopRequireDefault(require("../style/theme"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*:: import type { StylesheetClasses, Creator } from '../style/ThemeTypes';*/
var trasformClassNamesArrayToObject = function trasformClassNamesArrayToObject(classNames /*: Array<string>*/) {
  return /*: StylesheetClasses*/classNames.reduce(function (classes, className) {
    return _objectSpread(_objectSpread({}, classes), {}, (0, _defineProperty2.default)({}, className, className));
  }, {});
};

/**
 * Creates a mock classes object, which is a stub for the `classes` prop that would
 * come from `injectSheet(Style)`. Used for asserting that a shallow rendered
 * component snapshot applies classes as expected.
 */
var mockClasses = exports.mockClasses = function mockClasses(Style /*: Creator*/) /*: StylesheetClasses*/{
  var classNames = Object.keys(Style(_theme.default));
  return trasformClassNamesArrayToObject(classNames);
};
var _default = exports.default = mockClasses;
//# sourceMappingURL=mockClasses.js.map